import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { DashboardState } from 'reducers/dashboard';

const useDashboard = (): DashboardState => {
  return useSelector((state: RootState) => state.dashboard);
};

export default useDashboard;
